export async function base64ImageToBlob(content: string, mimeType: string) {
	const byteCharacters = atob(content);
	const bytes = new Array(byteCharacters.length);
	for (let i = 0; i < byteCharacters.length; i++) {
		bytes[i] = byteCharacters.charCodeAt(i);
	}
	const byteArray = new Uint8Array(bytes);
	return new Blob([byteArray], { type: mimeType });
}
